// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nipt: CountryValidator<"AL"> = createValidator(
  "al.nipt",
  3,
);

export default nipt;
export const compact = nipt.compact;
export const format = nipt.format;
export const validate = nipt.validate;
export const generate = (): string =>
  nipt.generate?.() ??
  (() => {
    throw new Error(
      "Validator al.nipt cannot generate values",
    );
  })();
